import { List } from 'immutable'
import { declareResourceType, IKeyMap } from 'rwwa-data-access'
import { TypedRecord, recordify } from 'typed-immutable-record'
import type { IAcceptorEx } from '../types'
import { getAcceptor, isDog, isTrot, isHorse } from '../integration'
import { fetchData } from '../helpers'

export enum MeetingCode {
  Races,
  Trots,
  Dogs,
  Unknown,
}

export interface IRace {
  key: string
  confidence: number
  comment: string
  earlySpeed: string
  longshotAcceptorKey: string
  longshotCalc: string
  meetingCode: MeetingCode
  sortedTopRunnerKeys: List<string>
  sortedAcceptorKeys: List<string>
  maidenAcceptorKeys: List<string>
  valueAcceptorKeys: List<string>
  updatedAt: string
}

export interface IRaceRecord extends TypedRecord<IRaceRecord>, IRace {}

export const GiddyUpRaces = declareResourceType<IRaceRecord, IRaceRecord>({
  typeKey: 'giddyUpRaces',
  fetchSingle: key => fetchData(`race/${key}`) as Promise<IKeyMap<IKeyMap<IRaceRecord>>>,
  map: convertJSRaceToImmutable,
  maxToKeep: 2,
  softTimeToLive: 60000,
})

function convertJSRaceToImmutable(race: IRace): IRaceRecord {
  // @ts-expect-error typing issue
  const acceptor = getAcceptor(race.sortedAcceptorKeys[0], 0) as IAcceptorEx
  if (isHorse(acceptor)) {
    race.meetingCode = MeetingCode.Races
  }
  if (isTrot(acceptor)) {
    race.meetingCode = MeetingCode.Trots
  }
  if (isDog(acceptor)) {
    race.meetingCode = MeetingCode.Dogs
  }

  return recordify<IRace, IRaceRecord>(race).merge({
    sortedTopRunnerKeys: race.sortedTopRunnerKeys,
    sortedAcceptorKeys: race.sortedAcceptorKeys,
    maidenAcceptorKeys: race.maidenAcceptorKeys,
    valueAcceptorKeys: race.valueAcceptorKeys,
  })
}
